import { useEffect } from "react";

/**
 * Sets document.title, meta description, canonical link, and OpenGraph/Twitter tags
 * for the current route. Also toggles a global <meta name="robots"> flag between
 * "noindex, nofollow" and "index, follow" based on the noindex prop, so admin/
 * payment routes don't get crawled.
 */
export default function useSEO({ title, description, path, image, noindex }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    if (image) setMeta("property", "og:image", image);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    if (image) setMeta("name", "twitter:image", image);

    if (path) {
      const canonicalUrl = `${window.location.origin}${path}`;
      setMeta("property", "og:url", canonicalUrl);
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonicalUrl);
    }
  }, [title, description, path, image, noindex]);
}
